export const attendanceMinutes = (value: number | string): number | null => {
  if (typeof value === "string") {
    const text = value.trim();
    if (!text) return null;
    const duration = text.match(/^(\d+):(\d{2})(?::(\d{2}))?$/);
    if (duration) {
      const minutes = Number(duration[2]);
      const seconds = Number(duration[3] ?? 0);
      if (minutes >= 60 || seconds >= 60) return null;
      return Math.round(Number(duration[1]) * 60 + minutes + seconds / 60);
    }
  }
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric >= 0 ? Math.round(numeric * 60) : null;
};

export const missingAttendanceMinutes = (expected: number | string, logged: number | string): number | null => {
  const expectedMinutes = attendanceMinutes(expected);
  const loggedMinutes = attendanceMinutes(logged);
  return expectedMinutes === null || loggedMinutes === null
    ? null : Math.max(0, expectedMinutes - loggedMinutes);
};

export const missingAttendanceHours = (expected: number | string, logged: number | string): string => {
  const minutes = missingAttendanceMinutes(expected, logged);
  if (minutes === null) return "-";
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  const minuteLabel = `${remainingMinutes} ${remainingMinutes === 1 ? "min" : "mins"}`;
  if (!hours) return minuteLabel;
  const hourLabel = `${hours} ${hours === 1 ? "hr" : "hrs"}`;
  return remainingMinutes ? `${hourLabel} ${minuteLabel}` : hourLabel;
};
